import { createTheme } from "@mantine/core";

// Mobilní motiv pro provoz v kuchyni: velké dotykové plochy (≥ 48 px) a vysoký kontrast.
export const theme = createTheme({
  primaryColor: "blue",
  primaryShade: { light: 7, dark: 5 },
  defaultRadius: "md",
  fontSizes: { xs: "0.875rem", sm: "1rem", md: "1.125rem", lg: "1.25rem", xl: "1.5rem" },
  components: {
    Button: { defaultProps: { size: "lg" } },
    ActionIcon: { defaultProps: { size: "xl" } },
    TextInput: { defaultProps: { size: "lg" } },
    NumberInput: { defaultProps: { size: "lg" } },
    Select: { defaultProps: { size: "lg" } },
    SegmentedControl: { defaultProps: { size: "md" } },
  },
});
